import * as React from 'react';
import CheckMarkIcon from '@narvar/nth-bit-icon-check-mark';
import { MediumHeader } from '@narvar/nth-bit-header';
import {
  useTranslations,
  withTranslationsProvider,
} from '@narvar/nth-hook-translations';

const SuccessPanel: React.FunctionComponent = () => {
  const { deliveryInstructionsSubmitSuccessText } = useTranslations();
  return (
    <div
      style={{ paddingTop: '0.5rem', display: 'flex', alignItems: 'center' }}
    >
      <CheckMarkIcon />
      <MediumHeader as="h2" containerCustomStyle={{ marginLeft: '1rem' }}>
        {deliveryInstructionsSubmitSuccessText}
      </MediumHeader>
    </div>
  );
};

export default withTranslationsProvider(SuccessPanel, {
  translationKeys: ['deliveryInstructionsSubmitSuccessText'],
});
